import Divider from '@shared/components/Divider/Divider';
import cx from 'classnames';
import { PropsWithChildren } from 'react';

import useCollapsibleContext from './useCollapsibleContext';

interface CollapsibleContentProps {
  hasDivider?: boolean;
  className?: string;
  containerClassName?: string;
  forceVisible?: boolean;
}

const CollapsibleContent = ({
  children,
  hasDivider = true,
  className,
  containerClassName,
  forceVisible = false,
}: PropsWithChildren<CollapsibleContentProps>) => {
  const { isCollapsed, isCollapsible } = useCollapsibleContext();

  if (!forceVisible && (isCollapsed || !isCollapsible)) return null;

  return (
    <div className={cx('pb-4 px-4 space-y-4', className)}>
      {hasDivider && <Divider />}
      <div className={cx('flex flex-col space-y-4', containerClassName)}>{children}</div>
    </div>
  );
};

export default CollapsibleContent;
